import createReducer from '../../utils/createReducer';

const initialState = {
  experiments: {}
};

export default createReducer(initialState, {});



// WEBPACK FOOTER //
// ./src/universal/redux/modules/abacus.js